export { default as ModelItem } from './component';
